import Style from "./style"

const TableLoading = ({ isLoading, children }) => {
    return (
        <Style.Container>
            {children}
            {isLoading && (
                <Style.Overlay>
                    <Style.Loader />
                </Style.Overlay>
            )}
        </Style.Container>
    )
}

export default TableLoading